export default {"src":"/_next/static/media/trade_option.f2593fa9.svg","height":22,"width":20};